// Diálogo para escolher qual conta de anúncios vincular (quando a autorização dá acesso a várias).
import { useState } from 'react'
import { X } from 'lucide-react'
import type { PendingSelectionDto } from '@impulso/shared/api/connections'
import { ErrorState, Loading, PlatformLogo } from '../../ui'
import { brand } from './format'

interface Props {
  pending: PendingSelectionDto | undefined
  loading: boolean
  error: unknown
  submitting: boolean
  submitError: string | null
  onSelect: (externalAccountId: string) => void
  onClose: () => void
}

export default function SelectAccountDialog({ pending, loading, error, submitting, submitError, onSelect, onClose }: Props) {
  const [picked, setPicked] = useState<string | null>(null)
  const available = pending?.options.filter((o) => !o.connectedToCompany) ?? []
  const choice = picked ?? (available.length === 1 ? available[0]!.externalAccountId : null)

  return (
    <>
      <div className="drawer-backdrop" onClick={onClose} />
      <div className="card" role="dialog" aria-modal="true" aria-label="Escolha a conta de anúncios"
        style={{ position: 'fixed', zIndex: 60, top: '50%', left: '50%', transform: 'translate(-50%,-50%)', width: 'min(480px, calc(100vw - 32px))', maxHeight: 'calc(100vh - 32px)', overflowY: 'auto', boxShadow: 'var(--shadow-lg)' }}>
        <div className="row between">
          {pending ? <PlatformLogo platform={brand(pending.provider)} size="lg" /> : <span />}
          <button className="icon-btn" onClick={onClose} aria-label="Fechar"><X size={16} /></button>
        </div>
        <h2 className="mt-16">Qual conta de anúncios você quer usar?</h2>
        {pending?.authorizedBy && <p className="small muted mt-8">Autorizado por {pending.authorizedBy}.</p>}
        <div className="stack mt-12" style={{ gap: 10 }}>
          {loading && <Loading lines={3} />}
          {!!error && <ErrorState error={error} />}
          {pending?.options.map((o) => {
            const taken = !!o.connectedToCompany
            return (
              <button key={o.externalAccountId} type="button" disabled={taken} className={`option-card ${choice === o.externalAccountId ? 'on' : ''}`}
                onClick={() => setPicked(o.externalAccountId)} aria-pressed={choice === o.externalAccountId} style={taken ? { opacity: 0.6, cursor: 'not-allowed' } : undefined}>
                <div style={{ minWidth: 0 }}>
                  <div className="strong" style={{ overflowWrap: 'anywhere' }}>{o.name}</div>
                  <div className="small muted">{o.currency} · {o.timezone.replace('_', ' ')}</div>
                  {taken && <div className="small mt-8" style={{ color: 'var(--amber)' }}>Já conectada à empresa "{o.connectedToCompany}".</div>}
                </div>
                {!taken && <span className="radio" />}
              </button>
            )
          })}
        </div>
        {submitError && <div className="form-error mt-12" role="alert">{submitError}</div>}
        <button className="btn primary block mt-16" disabled={!choice || submitting} onClick={() => choice && onSelect(choice)}>
          {submitting ? 'Conectando…' : 'Conectar esta conta'}
        </button>
      </div>
    </>
  )
}
